import React, { useEffect } from "react"
import { Form } from "reactstrap"
import { useForm, FormProvider } from "react-hook-form"

const QwikForm = ({
  onSubmit,
  children,
  defaultValues,
  resolver,
  className,
}) => {
  const methods = useForm({
    defaultValues: defaultValues || {}, // used only on first render
    resolver: resolver || undefined,
  })

  // update form if defaultValues change
  useEffect(() => {
    if (defaultValues) {
      methods.reset(defaultValues)
    }
  }, [defaultValues, methods])

  const submit = async data => {
    await onSubmit(data, methods)
  }

  return (
    <FormProvider {...methods}>
      <Form
        layout="vertical"
        onSubmit={methods.handleSubmit(submit)}
        className={className}
      >
        {children}
      </Form>
    </FormProvider>
  )
}

export default QwikForm
